import {TOKENS} from '../../tokens'

export const text = {
  dark: {
    default: TOKENS.dark.contrast_1000,
    medium: TOKENS.dark.contrast_700,
    low: TOKENS.dark.contrast_400,
    high: TOKENS.dark.contrast_900,
    inverted: TOKENS.dark.contrast_0,
  },
  light: {
    default: TOKENS.light.contrast_1000,
    medium: TOKENS.light.contrast_700,
    low: TOKENS.light.contrast_400,
    high: TOKENS.light.contrast_900,
    inverted: TOKENS.light.contrast_0,
  },
} as const
